import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  async submit(event) {
    event.preventDefault()
    const form = this.element

    form.classList.remove("form-success", "form-error")
    form.classList.add("unsubmitted")

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    let response
    try {
      response = await fetch(form.action, {
        method: form.method.toUpperCase() || "POST",
        headers: {
          "Accept": "application/json",
          "X-CSRF-Token": token || ""
        },
        body: new FormData(form)
      })
    } catch {
      form.classList.remove("unsubmitted")
      form.classList.add("form-error")
      return
    }

    form.classList.remove("unsubmitted")
    form.classList.add(response.ok ? "form-success" : "form-error")
  }
}
